/** Centralized timing / polling / cooldown constants. */

export const REFRESH_ON_FOCUS_THROTTLE_MS = 5_000;
export const SSE_RECONNECT_MS = 3_000;
export const SSE_MAX_RECONNECT_DELAY_MS = 60_000;
export const PERIODIC_REFRESH_MS = 60_000;
export const API_DEFAULT_TIMEOUT_MS = 30_000;
export const RESEND_COOLDOWN_SEC = 60;
export const PAY_STATUS_POLL_MS = 5_000;
